import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);
export const useAdminAccess = () => useContext(Ctx);

export function AdminAccessProvider({ children }) {
  const [access, setAccess] = useState(null); // null=loading, false=error/none, obj=ok

  const reload = useCallback(() => {
    return api.get("/admin/whoami")
      .then((r) => setAccess(r.data))
      .catch((e) => {
        if (e?.response?.status === 401) {
          localStorage.removeItem("smartemi_token");
          window.location.href = "/admin/login";
        } else {
          setAccess(false);
        }
      });
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const can = useCallback(
    (perm) => !!access && (access.is_super_admin || (access.permissions || []).includes(perm)),
    [access]
  );

  return (
    <Ctx.Provider value={{ access, can, isSuper: !!access?.is_super_admin, reload }}>
      {children}
    </Ctx.Provider>
  );
}
